import { useState } from 'react';

import { Button } from '@evaneos/b2b-ui';

import { useDisconnectCalendarMutation } from '../../../resources/appointment/mutations';

import { AppointmentDisconnectConfirmDialog } from './AppointmentDisconnectConfirmDialog';

export const AppointmentGoogleConnection = (): JSX.Element => {
    const { mutate: disconnectCalendar, isPending } = useDisconnectCalendarMutation();
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const handleConfirm = () => {
        disconnectCalendar('google');
        setIsDialogOpen(false);
    };

    return (
        <>
            <Button
                data-spec-id="agenda-disconnect-google-button"
                color="error"
                onClick={() => setIsDialogOpen(true)}
                disabled={isPending}
            >
                {/* @todo translate: agenda.google_connection.disconnect_button */}
                Déconnecter
            </Button>
            <AppointmentDisconnectConfirmDialog
                isOpen={isDialogOpen}
                onClose={() => setIsDialogOpen(false)}
                onConfirm={handleConfirm}
            />
        </>
    );
};
